(function(){
  var SEL='.variant-picker fieldset.variant-option--buttons:not(.variant-option--swatches)';

  function label(el){
    var t=el.querySelector('.variant-option__button-label__text');
    return (t?t.textContent:el.textContent).trim();
  }

  function build(fs){
    if(fs.getAttribute('data-tf-sel'))return;
    var labels=fs.querySelectorAll('.variant-option__button-label');
    if(labels.length<2)return;
    fs.setAttribute('data-tf-sel','1');

    var wrap=document.createElement('div');
    wrap.className='tf-vsel__w';
    var sel=document.createElement('select');
    sel.className='tf-vsel';
    var lg=fs.querySelector('legend');
    if(lg)sel.setAttribute('aria-label',lg.textContent.trim());

    Array.prototype.forEach.call(labels,function(l){
      var input=l.querySelector('input[type=radio]');
      if(!input)return;
      var o=document.createElement('option');
      o.value=input.value;
      o.textContent=label(l);
      if(input.getAttribute('data-option-available')==='false'){
        o.disabled=true;
        o.textContent=o.textContent+' \u2014 esaurito';
      }
      if(input.checked)o.selected=true;
      sel.appendChild(o);
    });

    sel.addEventListener('change',function(){
      var inputs=fs.querySelectorAll('input[type=radio]');
      for(var i=0;i<inputs.length;i++){
        if(inputs[i].value===sel.value){inputs[i].click();break}
      }
    });

    fs.addEventListener('change',function(e){
      if(e.target&&e.target.type==='radio'&&e.target.checked&&e.target.value!==sel.value){
        sel.value=e.target.value;
      }
    });

    wrap.appendChild(sel);
    fs.appendChild(wrap);
  }

  function run(root){
    var list=(root||document).querySelectorAll(SEL);
    Array.prototype.forEach.call(list,build);
  }

  function watch(){
    var pickers=document.querySelectorAll('variant-picker');
    Array.prototype.forEach.call(pickers,function(p){
      if(p.getAttribute('data-tf-watch'))return;
      p.setAttribute('data-tf-watch','1');
      var mo=new MutationObserver(function(){run(p)});
      mo.observe(p,{childList:true,subtree:true});
    });
  }

  function init(){run();watch()}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
  document.addEventListener('shopify:section:load',function(){setTimeout(init,60)});
})();
